/**
 * SHA-1 digest of a UTF-8 string as lowercase hex (40 chars). Uses Web Crypto (HTTPS/localhost).
 *
 * @param {string} utf8String
 * @returns {Promise<string>}
 */
export async function sha1Hex(utf8String) {
    const data = new TextEncoder().encode(utf8String);
    const hashBuffer = await crypto.subtle.digest('SHA-1', data);
    const bytes = new Uint8Array(hashBuffer);
    let hex = '';
    for (let i = 0; i < bytes.length; i += 1) {
        hex += bytes[i].toString(16).padStart(2, '0');
    }
    return hex;
}
